export const DISH_MODEL = {
    id: null,
    name: '',
    description: '',
    code: '',
    ingredients: [],
    allergenIds: [],
    dietTypeIds: [],
    isValidSetUpData: function () {
        return this.name !== '' && this.code !== '' && this.description !=='';
    },
    toRegister: function () {
        return {
            id: this.id,
            name: this.name,
            description: this.description,
            code: this.code,
            ingredients: this.ingredients,
            allergenIds: this.allergenIds,
            dietTypeIds: this.dietTypeIds,
        };
    },
    set: function (data) {
        return {
            ...this,
            id: data.id,
            name: data.name,
            description: data.description,
            code: data.code,
            ingredients:
                data.ingredients?.map((e) => ({
                    ingredientId: e.ingredientId,
                    ingredientName: e.ingredientName,
                    quantity: e.quantity,
                    unit: e.unit,
                })) || [],
            allergenIds: data.allergens?.map((e) => e.id) || [],
            dietTypeIds: data.diets?.map((e) => e.id) || [],
        };
    },
};
